import type { Business } from '../types';

export function exportToCsv(businesses: Business[], filename: string = 'business_export.csv'): void {
  if (businesses.length === 0) {
    console.warn("No businesses to export.");
    return;
  }

  const headers = ['Name', 'Address', 'Phone', 'Website', 'Email', 'Instagram', 'X', 'Facebook', 'LinkedIn', 'Yelp'];
  const csvRows = [headers.join(',')];

  const escapeCsvCell = (cell: string | undefined): string => {
    const cellValue = cell || '';
    // If the cell contains a comma, double quote, or newline, wrap it in double quotes.
    // Also, double up any existing double quotes.
    if (/[",\n]/.test(cellValue)) {
      return `"${cellValue.replace(/"/g, '""')}"`;
    }
    return cellValue;
  };

  businesses.forEach(business => {
    const row = [
      escapeCsvCell(business.name),
      escapeCsvCell(business.address),
      escapeCsvCell(business.phone),
      escapeCsvCell(business.website),
      escapeCsvCell(business.email),
      escapeCsvCell(business.instagram),
      escapeCsvCell(business.x),
      escapeCsvCell(business.facebook),
      escapeCsvCell(business.linkedin),
      escapeCsvCell(business.yelp),
    ];
    csvRows.push(row.join(','));
  });

  const csvString = csvRows.join('\n');
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
